<template lang="html">

    <div class="cover-popup row-center">

        <span class="close-cover" @click="close"></span>

        <div class="popup -pass row-center">

            <a @click="close" class="close">✕</a>

            <h2 class="title-pop">Cambiar contraseña</h2>

            <div class="contenedor-input">
                <label for="">Contraseña actual</label>
                <input type="password" v-model="data.anteriorPassword">
            </div>
            <div class="contenedor-input">
                <label for="">Nueva contraseña</label>
                <input name="contrasena" type="password" v-validate="'required|min:8'" v-model="data.nuevaPassword" ref="contrasena">
                <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('contrasena') }}</span>
            </div>
            <div class="contenedor-input">
                <label for="">Repetir contraseña</label>
                <input name="contrasena_2" type="password" v-validate="'required|min:8|confirmed:contrasena'" v-model="data.nuevaPassword2" data-vv-as="contrasena" @keyup.enter="send" >
                <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('contrasena_2') }}</span>
            </div>
    

            <div class="contenedor-botones row-center">
                <button class="btn" @click="send" :loading="loading">Guardar</button>
                <button class="btn -skull" @click="close">Cancelar</button>
            </div>
        </div>
    </div>


</template>

<script lang="js">

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    import {mapGetters,mapActions} from 'vuex';

    export default {
        name: 'popup-pass',
        methods:{
            ...mapActions(['modifyPass']),
            close(){
                this.$emit('close');
            },
            send() {
                this.clicked = true;
                this.$validator.validateAll()
                .then(itsOk => {
                    if (itsOk) {
                        this.loading = true;
                        this.modifyPass(this.data).then(r => {
                            this.loading = false;
                            this.close();
                        });
                    }
                });
            }
        },
        data() {
            return {
                data : {
                    nuevaPassword2 : '',
                    nuevaPassword : '',
                    anteriorPassword : '',
                },
                loading : false,
                clicked : false
            }
        },
        computed : {
            ...mapGetters({
                isCandidato : 'isCandidato',
                isEmpresa : 'isEmpresa',
            })
        }
    }
</script>

<style scoped lang="scss">
    .cover-popup .popup .btn {
        margin-top: 0;
    }

    .contenedor-input input[aria-invalid=false]{
        background: white;
    }

</style>


// WEBPACK FOOTER //
// src/components/parts/popup-pass.vue